<ng-container *ngTemplateOutlet="skeletonSide"></ng-container>

<ng-template #skeletonSide>
  <div class="card min-h-475px w-100 px-0">
    <div class="card-body d-flex flex-column justify-content-between p-8">
      <div class="d-flex flex-column">
        <div class="skeleton h-20px w-75 mb-4"></div>
        <div class="skeleton h-40px w-100 mt-4 mb-16"></div>
        <div class="skeleton h-20px w-75 mb-6"></div>
        <div class="d-flex flex-row align-items-center gap-2 mb-4">
          <div class="skeleton h-60px w-90px"></div>
          <div class="d-flex flex-column flex-fill gap-4">
            <div class="skeleton h-20px w-100"></div>
            <div class="skeleton h-15px w-100"></div>
          </div>
        </div>
        <div class="d-flex flex-row align-items-center gap-2 mb-4">
          <div class="skeleton h-60px w-90px"></div>
          <div class="d-flex flex-column flex-fill gap-4">
            <div class="skeleton h-20px w-100"></div>
            <div class="skeleton h-15px w-100"></div>
          </div>
        </div>
        <div class="d-flex flex-row align-items-center gap-2 mb-4">
          <div class="skeleton h-60px w-90px"></div>
          <div class="d-flex flex-column flex-fill gap-4">
            <div class="skeleton h-20px w-100"></div>
            <div class="skeleton h-15px w-100"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
